import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_73: FaireProductEntity = {
  token: "legacy_prod_abbott-73",
  type: "product",
  name: "Multi Cats Lined Notebook A5",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/c59527d572318537fbf649e22af3ab0835543650cfe8c24e00b1c4684d524a9a.jpeg",
  priceDollars: 10,
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_stationery-writing"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
